/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Observable, of } from 'rxjs';

import { AccessToken, LoginContext } from './authentication.service';

export class MockAuthenticationService {
  accessToken: AccessToken | null = {
    access_token: '123',
    token_type: '123',
    expires_in: '123',
    refresh_token: '123',
    profile: {
      email: '123',
      id: 123,
      roles: [{ id: 123, name: '123' }],
      settings: [{ name: '123', value: 123, collection: '123' }],
    },
  };

  login(context: LoginContext): Observable<AccessToken> {
    return of({
      access_token: '123',
      token_type: '123',
      expires_in: '123',
      refresh_token: '123',
    });
  }

  logout(): Observable<boolean> {
    this.accessToken = null;
    return of(true);
  }

  isAuthenticated(): boolean {
    return !!this.accessToken;
  }
}
